/**
 * Phase 1.5.3 — 顧客 LIFF キャンセル完了画面。
 *
 * 設計書 §7.3 のリライト後文言を表示し、再予約導線として
 * カレンダーへの戻りボタンを提供する。
 */

import { setRoot } from "../render";

export function renderCancelDone(): void {
  setRoot(`
    <div class="text-center pt-12 pb-8 px-2">
      <div class="text-4xl mb-4">✅</div>
      <h1 class="text-xl font-bold text-gray-900 mb-6">
        キャンセルを承りました。
      </h1>
      <div class="text-base text-gray-800 leading-relaxed space-y-1 mb-8">
        <p>ご連絡くださりありがとうございます😊</p>
        <p>ちょっとでも気になることがあれば</p>
        <p>いつでもお気軽にご相談ください✨</p>
        <p class="pt-3">お待ちしています^^</p>
      </div>
      <p class="text-sm text-gray-600 mb-4">
        下記のボタンから再度ご予約いただけます。
      </p>
      <div class="flex flex-col gap-2 max-w-xs mx-auto">
        <button id="btn-go-calendar"
          class="px-6 py-3 bg-brand text-white rounded-lg font-semibold">
          カレンダーから再予約
        </button>
        <button id="btn-close-liff"
          class="px-6 py-3 bg-gray-100 text-gray-700 rounded-lg">
          トーク画面に戻る
        </button>
      </div>
    </div>
  `);

  document.getElementById("btn-go-calendar")?.addEventListener("click", async () => {
    const { renderStep1 } = await import("../steps/step1Date");
    await renderStep1();
  });

  document.getElementById("btn-close-liff")?.addEventListener("click", () => {
    // LIFF 環境内なら window.liff.closeWindow() でトークに戻る。
    // 通常ブラウザ環境（dev など）では何もしない（noop）。
    const liff = (window as any).liff;
    if (liff && typeof liff.closeWindow === "function") {
      try {
        liff.closeWindow();
      } catch {
        // ignore
      }
    }
  });
}
